export default "__VITE_ASSET__e4727cc5__"